import axios from 'axios'

function axiosInsFn (options) {

    const { BASE_URL, store } = options

    const axiosIns = axios.create({
        baseURL: BASE_URL || '',
        headers: {
            'x-pathname': window.location.pathname,
            'x-origin': window.location.origin,
        }
    })
    
    
    axiosIns.interceptors.request.use(
        request => {
            if (request.page_overlay != false) {
                store.commit('testStore/PAGE_LOADING', true)
            }
            return request
        },
        error => Promise.reject(error),
    )
    
    axiosIns.interceptors.response.use(
        response => {
            store.commit('testStore/PAGE_LOADING', false)
            return response
        },
        error => {
            console.log('axiosIns.interceptors.response.use', 2)
            store.commit('testStore/PAGE_LOADING', false)
            return Promise.reject(error)
        },
    )
    
    
    axiosIns.ENDPOINT = {
    
        // Lấy thông tin đề thi
        GET_EXAM: '/get-questions',
    
        // Lấy bài thi đang làm theo mã đề
        GET_EXAM_HISTORY: '/get-test-history',
    
        // Lấy trackingId,
        INIT_TRACKID: '/track/init',
    
        // Tao bai test
        TEST_CREATE: '/test-create',
    
        // push contact
        PUSH_CONTACT: '/track/push-contact-v2',
    
        // Lưu bài test
        TEST_SAVE: '/test-save-v2',

        // push contact
        PUSH_SURVEY: '/track/push-survey',

        TEST_SUBMIT: '/test-submit',
    
        // Danh dau bai thi hoan thanh (truong hop bo qua bai thi dang lam)
        TEST_DONE: '/test-done',

        SITE_CONFIG: '/site/config',

        GET_TEST_RESULT: '/get-result'
    }

    return axiosIns
}

export default axiosInsFn
